// https://github.com/github/fetch#handling-http-error-statuses
export default function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  let error = new Error(response.statusText);
  error.response = response;
  throw error;
}



// WEBPACK FOOTER //
// ./src/utils/checkStatus.js